export function getYear(dateString: string): number {
  return +dateString.substring(0, 4);
}